<template>
  <div>
    <!-- Manager Dashboard Section -->
    <div class="manager-dashboard-section">
      <v-container class="fill-height">
        <v-layout column>
          <!-- Header Section -->
          <div class="dashboard-header py-6">
            <div class="d-flex justify-center align-center">
              <div class="header-content d-flex align-center">
                <img
                  src="@/assets/images/freed-small-logo.svg"
                  alt="Freed Logo"
                  class="freed-logo mr-3"
                />
                <h1 class="dashboard-title">Manager Dashboard</h1>
              </div>
            </div>
          </div>
          <!-- Filter and Performance Overview Section -->
          <f-p-p-sales-manager-dashboard-filter-metrics
            v-if="dsaLeadPerformanceInfo"
            :dsaAgentPerformanceData="
              dsaLeadPerformanceInfo.dsaAgentPerformanceData
            "
            :selectedFilter="selectedFilter"
            :customDateRange="customDateRange"
            :metrics="metrics"
            @filterChanged="applyFilter"
            @dateRangeChanged="handleCustomDateRangeSelect"
            @navigateToDetails="navigateToDetails"
            @clickedLeadDumpCta="handleLeadDumpCtaClick"
          ></f-p-p-sales-manager-dashboard-filter-metrics>
        </v-layout>
      </v-container>
    </div>

    <!-- Agent Performance Section -->
    <div class="agent-performance-section">
      <v-container>
        <component
          v-if="!!agentPerformanceFDataTableMetaData"
          :ref="agentPerformanceFDataTableMetaData.myRefName"
          :is="agentPerformanceFDataTableMetaData.componentName"
          :value="getDsaLeadDashboardDataOutput.dsaLeadDashboardDataList"
          v-bind="agentPerformanceFDataTableMetaData.props"
        >
        </component>


        <!-- lead-dump section  -->
        <component
          v-if="showQuestionAskedForm"
          :is="leadDumpQstnAskdFFormMetaData.componentName"
          :ref="leadDumpQstnAskdFFormMetaData.myRefName"
          @input="(newVal) => updateModel(this.questionAskedInput, newVal, undefined)"
          :value="selectModel(this.questionAskedInput, undefined)"
          v-bind="leadDumpQstnAskdFFormMetaData.props"
        ></component>

      </v-container>
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Component } from "vue-property-decorator";
import FDataTable from "@/components/table/FDataTable.vue";
import store, * as Store from "@/../src-gen/store";
import * as Data from "@/../src-gen/data";
import * as Action from "@/../src-gen/action";
import Helper from "@/util/Helper";
import FSnackbar from "@/fsnackbar";
import moment from "moment";
import FPPSalesManagerDashboardFilterMetrics from "./FPPSalesManagerDashboard/FPPSalesManagerDashboardFilterMetrics.vue";
import FPPSalesManagerDashboardAgentPerformanceFDataTableMDP from "./FPPSalesManagerDashboardAgentPerformanceFDataTableMDP";
import LeadDumpQstnAskdFFormMDP from "./LeadDumpQstnAskdFFormMDP";
import FDrawer from "@/components/FDrawer.vue";
import ModelVue from "@/components/ModelVue";
import FForm from "@/components/form/FForm.vue";
import FFormDrawer from "@/components/form/FFormDrawer.vue";

interface AgentPerformance {
  agentName: string;
  linksSent: number;
  signups: number;
  creditPulls: number;
  eligible: number;
  ineligible: number;
  transferred: number;
}

@Component({
  components: {
    FDataTable,
    FPPSalesManagerDashboardFilterMetrics,
    FFormDrawer
  },
})
export default class FPPSalesManagerDashboard extends ModelVue {
  @Store.Getter.Partner.ApplicantDetails.PartnerInfo
  ManagerInfo: Data.Partner.PartnerSummary;

  dsaLeadDashboardinput: Data.Partner.DsaLeadDashboardInput =
    new Data.Partner.DsaLeadDashboardInput();

  getDsaLeadDashboardDataOutput: Data.Partner.GetDsaLeadDashboardDataOutput =
    new Data.Partner.GetDsaLeadDashboardDataOutput();

  dsaLeadPerformanceInfo: any = new Data.Partner.DsaAgentPerformanceData();

  dsaLeadPerformanceInput: Data.Partner.DsaLeadDashboardInput =
    new Data.Partner.DsaLeadDashboardInput();

  questionAskedInput: Data.Insight.QuestionAskedInput = new Data.Insight.QuestionAskedInput();

  selectedFilter: string = "today";
  customDateRange: [string, string] = ["", ""];
  showQuestionAskedForm: boolean = false;
  metrics: any = {
    totalLinksSent: 0,
    totalSignups: 0,
    verifiedCreditPulls: 0,
    eligibleClients: 0,
    ineligibleClients: 0,
    transferred: 0,
  };

  agentPerformance: AgentPerformance[] = [];

  get agentPerformanceFDataTableMetaData() {
    return new FPPSalesManagerDashboardAgentPerformanceFDataTableMDP({
      parent: this,
    }).getMetaData();
  }

  get leadDumpQstnAskdFFormMetaData() {
    return new LeadDumpQstnAskdFFormMDP({
      parent: this, 
      isVisible: this.showQuestionAskedForm,
      onClose: () => {
        this.showQuestionAskedForm = false;
      }
    }).getMetaData();
  }

  applyFilter(filterValue: string) {
    this.selectedFilter = filterValue;
    this.filterAPI(filterValue);
  }

  handleCustomDateRangeSelect(dates: [string, string]) {
    this.customDateRange = dates;
    this.dsaLeadDashboardinput.fromDate = dates[0];
    this.dsaLeadDashboardinput.toDate = dates[1];
    this.getDsaLeadDashboardData();
    this.getDsaLeadPerformanceData();
  }

  navigateToDetails(type: string) {}

  filterAPI(filter: string) {
    switch (filter) {
      case "today":
        this.dsaLeadDashboardinput.fromDate =
          Helper.dateMTDWithCurrent().currentDate;
        this.dsaLeadDashboardinput.toDate =
          Helper.dateMTDWithCurrent().currentDate;
        break;
      case "last7Days":
        this.dsaLeadDashboardinput.fromDate =
          Helper.dateMTDWithCurrent().last7DaysToDate;
        this.dsaLeadDashboardinput.toDate =
          Helper.dateMTDWithCurrent().currentDate;
        break;
      case "last30Days":
        this.dsaLeadDashboardinput.fromDate =
          Helper.dateMTDWithCurrent().thirtyDaysAgo;
        this.dsaLeadDashboardinput.toDate =
          Helper.dateMTDWithCurrent().currentDate;
        break;
      case "custom":
        if (this.customDateRange[0] && this.customDateRange[1]) {
          this.dsaLeadDashboardinput.fromDate = this.customDateRange[0];
          this.dsaLeadDashboardinput.toDate = this.customDateRange[1];
        } else {
          this.dsaLeadDashboardinput.fromDate =
            Helper.dateMTDWithCurrent().startOfMonth;
          this.dsaLeadDashboardinput.toDate =
            Helper.dateMTDWithCurrent().currentDate;
        }
        break;
      default:
        this.dsaLeadDashboardinput.fromDate =
          Helper.dateMTDWithCurrent().currentDate;
        this.dsaLeadDashboardinput.toDate =
          Helper.dateMTDWithCurrent().currentDate;
        break;
    }
    this.getDsaLeadDashboardData();
    this.getDsaLeadPerformanceData();
  }

  refreshDashboard() {
    this.getDsaLeadDashboardData();
    this.getDsaLeadPerformanceData();
    FSnackbar.success("Dashboard refreshed");
  }

  getDsaLeadDashboardData(showSuccessMessage: boolean = false) {
    this.dsaLeadDashboardinput.offset = 0;
    this.dsaLeadDashboardinput.count = 1000;
    Action.Partner.GetDsaLeadDashboardData.execute(
      this.dsaLeadDashboardinput,
      (output) => {
        if (output == null) {
          if (showSuccessMessage) {
            FSnackbar.error("Error refreshing data");
          }
          return;
        }
        this.getDsaLeadDashboardDataOutput = output;

        if (showSuccessMessage) {
          FSnackbar.success("Data refreshed successfully");
        }
      },
      (error) => {
        console.error("Error fetching DSA Lead Dashboard Data", error);
        if (showSuccessMessage) {
          FSnackbar.error("Error refreshing data");
        }
      }
    );
  }

  getDsaLeadPerformanceData() {
    Action.Partner.GetDsaLeadPerformanceData.execute(
      this.dsaLeadDashboardinput,
      (output) => {
        if (output == null) {
          return;
        }
        this.dsaLeadPerformanceInfo = output;
      },
      (error) => {
        console.error("Error fetching DSA Lead Performance Data", error);
      }
    );
  }

  handleLeadDumpCtaClick() {
    this.showQuestionAskedForm = true;
  }

  dumpReqQuestionAsked() {
    Action.Insight.QuestionAsked.execute(
      this.questionAskedInput,
      (output) => {
        // console.log("output", output);
        this.showQuestionAskedForm = false;
        FSnackbar.success("Request Noted Successfully");
      },
      (error: any) => {
        console.log("error in QuestionAsked api", error);
        this.showQuestionAskedForm = false;
        FSnackbar.error(
          error.response?.data[0].message ||
            error.message ||
            "Something went wrong."
        );
      }
    );
  }

  mounted() {
    console.log("Manager Dashboard")
    this.filterAPI("today");
    // Load lead dashboard data on mount
    this.getDsaLeadDashboardData();
  }
}
</script>

<style lang="scss" scoped>
.manager-dashboard-section {
  background-color: #ffffff;
  width: 100%;
}

.agent-performance-section {
  width: 100%;
  padding: 20px 0;
}

.dashboard-title {
  font-size: 28px;
  color: #00447a;
}

.freed-logo {
  height: 40px;
  width: auto;
}

@media (min-width: 1264px) {
  ::v-deep .container {
    max-width: 1440px;
  }
}
</style>
